import styled from 'styled-components';

export const Container = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-family: 'Open Sans', sans-serif;
  margin-top: 15px;
`;
Container.displayName = 'Container';

export const Header = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
`;
Header.displayName = 'Header';

export const Logo = styled.img`
  position: absolute;
  top: -16px;
  z-index: 2;
`;
Logo.displayName = 'Logo';

const Points = styled.div`
  color: #ffffff;
  font-size: 82px;
  font-weight: 800;
  line-height: 48px;
  z-index: 2;
`;
Points.displayName = 'Points';

export const PointsAway = styled(Points)`
  margin: 0px 0px 12px 16px;
`;
PointsAway.displayName = 'PointsAway';

export const PointsHome = styled(Points)`
  margin: 0px 16px 12px 0px;
`;
PointsHome.displayName = 'PointsHome';

const TeamBackground = styled.svg`
  position: absolute;
  z-index: 1;
`;

export const TeamBackgroundAway = styled(TeamBackground)`
  left: 44px;
`;
TeamBackgroundAway.displayName = 'TeamBackgroundAway';

export const TeamBackgroundHome = styled(TeamBackground)`
  right: 44px;
`;
TeamBackgroundHome.displayName = 'TeamBackgroundHome';

const TeamContainer = styled.div`
  align-items: center;
  display: flex;
  height: 48px;
  justify-content: space-between;
  min-width: 226px;
  padding: 0px 16px;
  position: relative;
`;

export const TeamContainerAway = styled(TeamContainer)`
  background: #ecfc2b;
  border-radius: 0px 10px 0px 0px;
`;
TeamContainerAway.displayName = 'TeamContainerAway';

export const TeamContainerHome = styled(TeamContainer)`
  background: #0e0a92;
  border-radius: 10px 0px 0px 0px;
`;
TeamContainerHome.displayName = 'TeamContainerHome';

export const TeamName = styled.div`
  color: #ffffff;
  font-size: 48px;
  font-weight: 800;
  letter-spacing: -1.5px;
  line-height: 42px;
`;
TeamName.displayName = 'TeamName';

export const TimerContainer = styled.div`
  align-items: center;
  background: #37003c;
  border-radius: 0px 0px 10px 10px;
  display: flex;
  height: 35px;
  justify-content: center;
  width: 142px;
`;
TimerContainer.displayName = 'TimerContainer';

export const Timer = styled.div`
  color: #ffffff;
  font-size: 32px;
  font-weight: 700;
  text-align: center;
`;
Timer.displayName = 'Timer';
